import PropTypes from 'prop-types';
import { cn } from '../../utils/cn';

/**
 * Spinner component for loading states
 * @param {object} props - Component props
 * @param {string} props.size - Spinner size: "sm" | "md" | "lg"
 * @param {string} props.color - Spinner color variant: "primary" | "white" | "cta"
 * @param {string} props.className - Additional CSS classes
 */
const Spinner = ({
  size = 'md',
  color = 'primary',
  className,
}) => {
  const sizeStyles = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-[3px]',
    lg: 'w-12 h-12 border-4',
  };

  const colorStyles = {
    primary: 'border-primary border-t-transparent',
    white: 'border-white border-t-transparent',
    cta: 'border-cta border-t-transparent',
  };

  return (
    <div
      className={cn(
        'inline-block rounded-full animate-spin',
        sizeStyles[size],
        colorStyles[color],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['primary', 'white', 'cta']),
  className: PropTypes.string,
};

export default Spinner;























